import React, {Component} from 'react'
import TagsInput from 'react-tagsinput'
import AutoSuggestTags from '../components/auto_suggest_tags';

// If using WebPack and style-loader.


export default class TagInputter extends Component {
  constructor(props) {
    super()
    this.state = {tags: props.tags, tag_suggestions: []}
    this.form_name = props.form_name
    this.renderHiddenInputs = this.renderHiddenInputs.bind(this);
    this.handleChange = this.handleChange.bind(this);

  }

   handleChange(tags) {

    this.setState({tags})
  }

  
  renderHiddenInputs(){
    let t = this;
    return  this.state.tags.map(function (tag, index){
        return (<input hidden key={index} type="text" name={t.form_name} readOnly="true" value={tag}/>);
      });
  }

  render() {
   let t = this;

    function autocompleteRenderInput ({addTag, ...props}) {
      return (

        <AutoSuggestTags 
         endpoint={t.props.endpoint}
          ref={props.ref}
          inputProps={{...props}}
          onSuggestionSelected={(e, suggestion) => {
            addTag(suggestion.name)
          }}
        
        />
      )
    }

    return (
      <div>
      <TagsInput onlyUnique={true} value={this.state.tags} renderInput={autocompleteRenderInput} onChange={this.handleChange} />
       {this.renderHiddenInputs()}
      </div> 

      );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/app/roots/tag_inputter.jsx